import AclName from '../AclName';

export default [
  AclName.StaffAccessAll,
  AclName.BookkeepingPageDeclarationsPitList,
  AclName.BookkeepingPageZusCompanySettlementsList,
  AclName.StaffPageAccidentInsurancesList,
  AclName.StaffPageAccidentInsurancesEdit,
];
